<template>
    <div class="ig-radial-chart">
        <apexchart
        :ref="`igTotal-${igId}`"
        type="donut"
        :options="chartOptions"
        :series="datas.series"
        />
        <div class="dc-chart-label">
            <span class="lb-total" :title="datas.label[0]">{{ datas.series[0] }}</span>
            <span class="lb-plus" :class="classVariacao(datas.tipo)" :title="datas.label[1]">{{ datas.series[1] }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardIg',
    props: ['datas'],
    data() {
        return {
            igId: null,
            chartOptions: {
                plotOptions: {
                    pie: {
                        startAngle: -90,
                        endAngle: 90,
                        offsetY: 0,
                        donut: {
                            size: "80%",
                        },
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    show: false,
                },
                colors: ["#0054ff", "#00cc66", "#d9d9d9"],
                labels: []
            }
        }
    },
    watch: {
        datas: {
            handler(dt) {
                if(!dt) {return }

                this.chartOptions.labels = dt.label;
                this.updateChart();
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        updateChart() {
            if(!this.$refs[`igTotal-${this.igId}`]) { return }
            this.$refs[`igTotal-${this.igId}`].updateOptions(this.chartOptions);
        },
        classVariacao(tipo) {
            let cl = ''

            if(tipo === 0) {
                cl = 'lb-red'
            } else if(tipo === 1) {
                cl = 'lb-green'
            } else {
                cl = 'lb-orange'
            }

            return cl
        }
    },
    created() {
      this.igId = this.generateSecureId();
    },
}
</script>
<style lang="scss">
    .ig-radial-chart {
        text-align:Center;
        position: relative;
        height: 100%;
        margin-bottom: 5px;
        .dc-chart-label {
            position: absolute;
            top: 43%;
            width: 96%;
            z-index: 1;
            .lb-total {
                font-size: 30px;
                font-weight: bold;
            }
            .lb-plus {
                position: absolute;
                margin: -10px 0;
                color: #9b9b9b;
                &.lb-green:before {
                    content: '🠉';
                    margin-right: 2px;
                    color:#00cc66;
                }
                &.lb-red:before {
                    content: '🠋';
                    margin-right: 2px;
                    color:#FF3033;
                }
                &.lb-orange:before {
                    content: '●';
                    margin-right: 2px;
                    color:#FF8C00;
                }
            }

            @media screen and (max-width: 1200px) {
                .lb-total {
                    font-size: 50px;
                }
                .lb-plus {
                    font-size: 20px;
                    margin-left: -15px;
                } 
            }
            @media screen and (max-width: 800px) {
                .lb-total {
                    font-size: 3em;
                }
            }
            @media screen and (max-width: 600px) {
                .lb-total {
                    font-size: 1.8em;
                }
            }
        }
    }
    
    
</style>
